import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarSlim } from '../TopBarSlim';
import { UseCaseVariationEnums } from '../TopBarSlimEnums';
import { Link, Typography } from '@sm/wds-react';

const DEFAULT_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseBallotVotingTopBarSlim.message',
    defaultMessage:
      'Customize the voting experience with logic that skips past irrelevant questions.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseBallotVotingTopBarSlim.ctaText',
    defaultMessage: 'See all plans',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const COLLECT_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseBallotVotingTopBarSlim.messageCollect',
    defaultMessage:
      'Make sure every vote counts. { ctaTextCollect } to unlock unlimited survey responses.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseBallotVotingTopBarSlim.ctaTextCollect',
    defaultMessage: 'Upgrade your plan',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const ANALYZE_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseBallotVotingTopBarSlim.messageAnalyze',
    defaultMessage:
      'Share the voting results. Export and print results with upgraded plans.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseBallotVotingTopBarSlim.ctaTextAnalyze',
    defaultMessage: 'See all plans',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

export type UseCaseBallotVotingTopBarSlimProps = {
  variation?: UseCaseVariationEnums | null;
};

const VariationToCopy = {
  [UseCaseVariationEnums.create]: DEFAULT_COPY,
  [UseCaseVariationEnums.collect]: COLLECT_COPY,
  [UseCaseVariationEnums.analyze]: ANALYZE_COPY,
};

export const UseCaseBallotVotingTopBarSlim: React.FC<UseCaseBallotVotingTopBarSlimProps> = ({
  variation,
}) => {
  const copy =
    variation && variation in VariationToCopy
      ? VariationToCopy[variation]
      : DEFAULT_COPY;
  const ut_source = variation
    ? `slim_${variation}_upsell_ballots_voting`
    : 'slim_create_upsell_ballots_voting';
  const url = createURL('/pricing/upgrade/', {
    ut_source: 'topbar',
    ut_source2: ut_source,
  });

  // For the collect variant, the CTA is displayed as part of the message.
  const ctaTextCollect = (
    <Link className="wds-display--inline-block" href={url} target="_blank">
      <Typography className={`sm-top-bar-slim--info__cta-text`}>
        {t(copy.CTA_TEXT)}
      </Typography>
    </Link>
  );

  return (
    <TopBarSlim
      message={t(copy.MESSAGE, { ctaTextCollect })}
      ctaText={
        variation != UseCaseVariationEnums.collect
          ? t(copy.CTA_TEXT)
          : undefined
      }
      ctaLink={url}
      ctaNewTab
    />
  );
};

export default UseCaseBallotVotingTopBarSlim;
